module.exports = __webpack_public_path__ + "img/chieftain.d2b75d71.png";